/*  global jQuery, $  */
jQuery(document).ready(function () {
  // 手機側邊選單
  $('nav#menu').mmenu({
    drag: true,
    pageScroll: {
      scroll: true,
      update: true
    },
    'extensions': [
      'theme-dark',
      'fx-menu-fade',
      'fx-listitems-slide'
    ]
  }, {
    classNames: {
      fixedElements: {
        fixed: 'fix',
        sticky: 'sticky-top'
      }
    }
  })
  // Header Sticker
  $('#pageHeader').sticky({topSpacing: 0})
  $('#pageHeader').on('sticky-end', function () { $(this).parent('.sticky-wrapper').css({height: 'auto'}) }) // sticky 補丁
  $('#pageHeader').on('sticky-start', function () { $(this).addClass('is-sticky fixed animated fadeInDown') });
  $('#pageHeader').on('sticky-end', function () { $(this).removeClass('is-sticky fixed animated fadeInDown') });
  // Header 捲動
  // $(window).bind('scroll', function () {
  //   var top = 100;
  //   if ($(document).scrollTop() > top) {
  //     $('#pageHeader').addClass('is-sticky fixed animated fadeInDown')
  //   } else {
  //     $('#pageHeader').removeClass('is-sticky fixed animated fadeInDown')
  //   }
  // })

  AOS.init();

  // function warmingBarFixed() {
  //   var h = $('#warningContainer').outerHeight()
  //   $('#footer').css('margin-bottom',h)
  //   console.log('高度'+h);
  // }
  // warmingBarFixed()

  $('.dropdown-hover').dropdownHover(100)

  // $('#twmapSidler').slick({
  //   dots: true,
  //   infinite: true,
  //   speed: 600,
  //   slidesToShow: 2
  // });

  $().UItoTop({ easingType: 'easeOutQuart', text: '<i class="icon-up-small"></i>' })

  $('.lazy').Lazy()

  // $('.slick-slider').mouseover(function () {
  //   var _this = $(this)
  //   _this.find('.slick-next').addClass("animated bounceInRight")
  //   _this.find('.slick-prev').addClass("animated bounceInLeft")
  // })

  $('.wms-listgroup').find('.list-group-item').mouseover(function() {
    var _this = $(this)
    _this.siblings().removeClass("active")
    _this.addClass("active")
  })

});


(function ($) {
  $.fn.timeline = function () {
    var selectors = {
      id: $(this),
      item: $(this).find(".timeline-item"),
      activeClass: "timeline-item--active"
    };
    selectors.item.eq(0).addClass(selectors.activeClass);
    var itemLength = selectors.item.length;
    $(window).scroll(function () {
      var max, min;
      var pos = $(this).scrollTop();
      selectors.item.each(function (i) {
        min = $(this).offset().top - 80;
        max = $(this).height() + $(this).offset().top;
        var that = $(this);
        if (i == itemLength - 2 && pos > min + $(this).height() / 2) {
          selectors.item.removeClass(selectors.activeClass);
          // selectors.id.css(
          //   "background-image",
          //   "url(" +
          //   selectors.item
          //     .last()
          //     .find(selectors.img)
          //     .attr("src") +
          //   ")"
          // );
          selectors.item.last().addClass(selectors.activeClass);
        } else if (pos <= max - 40 && pos >= min) {
          // selectors.id.css(
          //   "background-image",
          //   "url(" +
          //   $(this)
          //     .find(selectors.img)
          //     .attr("src") +
          //   ")"
          // );
          selectors.item.removeClass(selectors.activeClass);
          $(this).addClass(selectors.activeClass);
        }
      });
    });
  };
})(jQuery);

$("#timeline").timeline();

